export function getGlobalParams () {
  try {
    return SodaBridge('getGlobalParams', 'badcase').then(resp => {
      return getBridgeData(resp)
    })
  } catch (e) {
    console.log(e)
  }
}

// 用户信息
export function getUserInfo () {
  return SodaBridge('getUserInfo', {}).then(resp => {
    return getBridgeData(resp)
  })
}

// 商铺信息
export function getShopInfo () {
  return SodaBridge('merchant.getShopInfo', 'badcase').then(resp =>
    getBridgeData(resp)
  )
}

// 骑手信息
export function getRiderInfo () {
  return SodaBridge('delivery.getRiderInfo', 'badcase').then(resp =>
    getBridgeData(resp)
  )
}

// 骑手端：展示端上功能 style 的值为2 表示菜单 1表示返回键
export function getRiderBackBtn (style = 1) {
  const Soda = window.Soda || {}
  Soda.rider.updateMainPageLeftItemStyle({
    style: style
  })
}

export function getContractorInfo () {
  return SodaBridge('merchant.getContractorInfo', 'badcase').then(resp =>
    getBridgeData(resp)
  )
}

export function openPage () {
  return SodaBridge('merchant.openPage', 'badcase').then(resp =>
    getBridgeData(resp)
  )
}

export function setTitle (naviTitle, timeout) {
  // 延时设置标题，处理ios设置不成功问题
  setTimeout(() => {
    SodaBridge('setTitle', { 'navi_title': naviTitle })
  }, timeout || 300)
}
export function setNavigationBarStyle (navInfo, timeout) {
  // 延时设置标题，处理ios设置不成功问题
  setTimeout(() => {
    SodaBridge('setNavigationBarStyle', navInfo)
  }, timeout || 300)
}

export function closePage () {
  return SodaBridge('closePage').then(resp => {
    getBridgeData(resp)
  })
}
export function getLocationInfo () {
  return SodaBridge('getLocationInfo', {}).then(resp => {
    getBridgeData(resp)
  })
}

function getBridgeData (resp = {}) {
  let { errno = 0 } = resp
  if (errno.toString() === '0') {
    return resp.data || resp
  }
}
